import { isArray, isObject, isUndefined, forEach } from 'lodash';
import { ENTRYPOINT } from '../config/entrypoint';
import SubmissionError from '../error/SubmissionError';
import store from "../store/store";
import router from "../router/router";

const MIME_TYPE = 'application/ld+json';

const transformRelationToIri = (payload) => {
  forEach(payload, (value, property) => {
    if (isObject(value) && !isUndefined(value['@id'])) {
      payload[property] = value['@id'];
    }

    if (isArray(value)) payload[property] = transformRelationToIri(value);
  });

  return payload;
};

export default function(id, options = {}) {
  if ('undefined' === typeof options.headers) options.headers = new Headers();

  const accessToken = localStorage.getItem("access-token");
  if (accessToken != "") {
    // console.log(accessToken);
    options.headers.set("Authorization", "Bearer " + accessToken);
  }

  if (null === options.headers.get('Accept'))
    options.headers.set('Accept', MIME_TYPE);

  if (
    'undefined' !== options.body &&
    !(options.body instanceof FormData) &&
    null === options.headers.get('Content-Type')
  )
    options.headers.set('Content-Type', MIME_TYPE);

  const payload = options.body && JSON.parse(options.body);
  if (isObject(payload) && payload['@id'])
    options.body = JSON.stringify(transformRelationToIri(payload));

  return global.fetch(new URL(id, ENTRYPOINT), options).then(response => {
    if (response.ok) return response;

    return response.json().then((json) => {
      const error = json['hydra:description'] || response.statusText;
      if (!json.violations) throw Error(error);

      let errors = { _error: error };
      json.violations.map(
        violation => (errors[violation.propertyPath] = violation.message)
      );

      throw new SubmissionError(errors);
    })
    .catch(() => {
      console.log("Error:", response);
      if (response.status == 401 || response.statusText == 'Unauthorized') {                          
          store.dispatch("refreshToken/useRefreshToken", null, { root: true })
          .then(response => {
            console.log("Status:", response);
            if (response.status == 200 || response.status == 204) {
              store.dispatch("refreshToken/resetTokens", response)
              .then(() => {               
                location.reload();                                               
              }) 
              .catch(error => {
                console.log('Err dispach resetTokens:',error);
                store.dispatch("auth/authLogout").then(() => {
                  router.push("/login");
                });                                
              })              
            }            
          })
          .catch(error => {
            console.log('Err dispach useRefreshToken:',error);            
            store.dispatch("auth/authLogout").then(() => {
              router.push("/login");
            });            
          })        
        }
    });
  });
}



// WEBPACK FOOTER //
// ./src/utils/fetch.js